export const buildApplicableUrl = (special) => {
  const params = [];
  if (special.filter_make !== undefined && special.filter_make !== "")
    params.push(
      `_dFR%5Bmake%5D%5B0%5D=${encodeURIComponent(special.filter_make)}`
    );
  if (special.filter_model !== undefined && special.filter_model !== "")
    params.push(
      `_dFR%5Bmodel%5D%5B0%5D=${encodeURIComponent(special.filter_model)}`
    );
  if (special.filter_year !== undefined && special.filter_year !== "")
    params.push(
      `_dFR%5Byear%5D%5B0%5D=${encodeURIComponent(special.filter_year)}`
    );
  if (special.filter_trim !== undefined && special.filter_trim !== "All")
    params.push(
      `_dFR%5Btrim%5D%5B0%5D=${encodeURIComponent(special.filter_trim)}`
    );

  if (special.new == "1") params.push(`_dFR%5Btype%5D%5B0%5D=New`);
  else if (special.new == "0") params.push(`_dFR%5Btype%5D%5B0%5D=Used`);

  const query = params.length ? `?${params.join("&")}` : "";
  return `https://www.westherr.com/all-vehicles/${query}`;
};

export const toyotaTruckSuffix = (vehicle) => {
  if (vehicle.make !== "Toyota" || !/pickup/i.test(vehicle.body || "")) return "";
  const cabStyle = (vehicle.body || "").replace(/ Pickup$/i, "").trim();
  const parts = [];
  if (vehicle.drivetrain) parts.push(vehicle.drivetrain);
  if (cabStyle) parts.push(cabStyle);
  return parts.length ? ` ${parts.join(" ")}` : "";
};

export const formatPercent = (value) => {
  const pct = value.substring(0, 4);
  // Adds a zero if the percent ends with a period
  return pct.endsWith(".") ? pct + 0 : pct;
};
